<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col head">
                            <h3 class="mb-0">
                              Assinaturas
                            </h3>

                            <!--<base-button size="sm" class="clickable" @click="goCsv()">Exportar</base-button>-->
                          </div>
                        </div>
                      </div>

                      <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>


                      <!-- Card stats -->
                      <div class="row" v-if="!loading && facets.ira_renovar" style="padding: 20px 20px 40px 20px;">
                         <div class="col-xl-3">
                              <stats-card title="Tipo"
                                          type="gradient-primary"
                                           v-bind:sub-title="facets.plano_descritivo || 'Nenhum Plano'"
                                          icon="fas fa-leaf"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">seu plano assinado.</span>
                                  </template>
                              </stats-card>
                          </div>
                          <div class="col-xl-3">
                              <stats-card title="Valor"
                                          type="gradient-primary"
                                           v-bind:sub-title="'R$' + (facets.ultimo_valor_pago / 100).toLocaleString('pt-br', {minimumFractionDigits: 2})"
                                          icon="fas fa-dollar-sign"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">pago mensalmente.</span>
                                  </template>
                              </stats-card>
                          </div>
                          <div class="col-xl-3">
                              <stats-card title="Pagamento"
                                          type="gradient-primary"
                                          v-bind:sub-title="formatarData2(facets.ultimo_pagamento) || 'Nenhum Dado'"
                                          icon="fas fa-calendar"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">seu último pagamento.</span>
                                  </template>
                              </stats-card>
                          </div>

                          <div class="col-xl-3">
                            <stats-card title="Renovação"
                                        type="gradient-primary"
                                        v-bind:sub-title="formatarData2(facets.proximo_pagamento)"
                                        icon="fas fa-undo"
                                        class="mb-4 mb-xl-0"
                            >

                                <template slot="footer">
                                    <span class="text-light">seu próximo pagamento.</span>
                                </template>
                            </stats-card>
                        </div>
                      </div>

                      <!-- Card stats -->
                      <div class="row" v-if="!loading && !facets.ira_renovar" style="padding: 20px 20px 40px 20px;">
                         <div class="col-xl-12">
                              <stats-card title="plano"
                                          type="gradient-primary"
                                           v-bind:sub-title="'Nenhum Plano Ativo'"
                                          icon="fas fa-pen-fancy"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">assine para ter acesso completo.</span>
                                  </template>
                              </stats-card>
                          </div>
                      </div>

                        <div class="px-3 mb-4 text-right" v-if="facets.ira_renovar">
                             <base-button size="sm" class="clickable" @click="goCancel()"> <i class="fas fa-hand-paper"></i> Cancelar Minha Assinatura</base-button>
                        </div>

                         <div class="px-3 mb-4 text-right" v-if="!facets.ira_renovar">
                             <base-button size="sm" class="clickable" @click="goSign()"> <i class="fas fa-pen-fancy"></i> Assine agora mesmo!</base-button>
                        </div>

                     
                      
                      <div class="d-flex column px-3 mb-4">
                        <h3 class="mb-0" style="padding-top: 30px">
                              Minhas Faturas
                        </h3>
                    </div>

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="faturasList">
                            <template slot="columns">
                              <th>Nome Completo / Razão Social</th>
                              <th>E-mail</th>
                              <th>Descrição do Pagamento</th>
                              <th>Valor</th>
                              <th>Data do Pagamento</th>
                              <th>Data de Criação</th>
                              <th class="text-center">Ações</th>
                             
                            </template>

                            <template slot-scope="{row}" v-if="!loading">
                              <td>
                                {{ row.titular_nome || '-' }}
                              </td>
                                <td>
                                {{ row.titular_email }}
                              </td>
                                <td>
                                  {{ row.descritivo }}
                              </td>
                               <td>
                                R$ {{ (row.valor_pagamento / 100).toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                              </td>
                                <td>
                                <span class="name mb-0 text-sm"> {{formatarData(row.data_pagamento)}}</span>
                              </td>
                              <td>
                                <span class="name mb-0 text-sm"> {{formatarData(row.created_at)}}</span>
                              </td>

                              <td class="text-center actions">
                                <a @click="goExternal(row.fatura_pdf)" title="Fatura em PDF">
                                  <i class="fas fa-file-pdf"></i>
                                </a>

                                <a  @click="goExternal(row.fatura_url)" title="Fatura via link">
                                  <i class="fas fa-file-alt"></i>
                                </a>
                              </td>
                           

                            </template>

                          </base-table>
                        </template>
                      </div>

                       <div class="card-footer d-flex justify-content-center" v-if="!loading">
                        <span class="text-size-xl cursor" @click="loadMore()">
                          <i class="fas fa-chevron-circle-down"></i>
                        </span>
                      </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import minhaAssinatura from '@/cflow/minhaAssinatura.js'
  //import parametros from "@/cflow/parametros.js";
  //import BaseButton from '../components/BaseButton.vue';
  //import BaseInput from '../components/BaseInput.vue';
  //import Multiselect from "vue-multiselect";
  import storage from 'storage';

  export default {
    name: 'tables',
    components: {
     // Multiselect,
     // BaseButton,
     // BaseInput
    },
    methods: {
      goCancel: function() {
          window.location = '/#/cancelar-assinatura';
      },
       goSign: function() {
          window.location = 'https://conectflow.com.br/';
      },
        setTipo: function(tipo, flag) {
        let tiposList;
        if(flag == 'color') tiposList = { 'refunded' : 'default', 'plano_dentista' : 'info'};
        if(flag == 'label') tiposList = { 'refunded' : 'Reembolso', 'plano_dentista' : 'Dentista'};
       for (let key in tiposList) {
            if(tipo == key) {
                return tiposList[key];
            }
        }
      },
      setStatus: function(status, flag) {
        let statusList;
        if(flag == 'color') statusList = { 'pending' : 'warning', 'paid' : 'success', 'authorized' : 'info', 'refunded': 'info', 'expired' : 'secondary', 'canceled': 'danger'};
        if(flag == 'label') statusList = { 'pending' : 'Pendente', 'paid' : 'Pago', 'authorized' : 'Autorizado', 'refunded': 'Reembolsado', 'expired' : 'Expirado', 'canceled': 'Cancelado'};
       for (let key in statusList) {
            if(status == key) {
                return statusList[key];
            }
        }
        if(flag == 'color') return 'secondary';
        if(flag == 'label') return 'Outros';
      },
      aplicarFiltros() {
        this.filtroAberto = !this.filtroAberto
        if(this.filtrosAlterados){
          // se os filtros mudaram, então aplicar eles.
          this.aplicandoFiltros = true;
          this.loading = true;
          minhaAssinatura.listar({filtros: this.filtros}, 0).then(res => {
            this.faturasList = res.faturas.items;
            //this.facets = this.filterStatus(res.faturas.facets);
             this.assinaturaDetails = false;
          if(res.assinatura) {
            this.assinaturaDetails = res.assinatura;
          }
            this.aplicandoFiltros = false;
            this.filtrosAlterados = false;
            this.loading = false;
          }).catch(() => {
            this.aplicandoFiltros = false;
          })
        }
      },
      limparFiltros() {
        this.filtros = {
          numero: null,
          data: null,
          status: null,
          dentista: null,
          paciente: null
        }
      },
      loadMore: function() {
        this.skiped += this.faturasList.length;
        this.initLoad(this.skiped);
      },
      filterStatus: function(facets) {
        const terms = facets.status.terms;
        let status = {};
        for (let key in terms) {
           status[terms[key].term] =  terms[key].count;
        }
        return status;
      },
      initLoad: function() {
        this.loading = true;
        var user = storage.get("user");
        //var labId = 0;
        if(user.tipo && user.tipo == 'lab') {
          //labId = user.id;
        }
        Promise.all([minhaAssinatura.listar([], this.skiped)]).then( res => {
            this.loading = false;
          this.faturasList = this.faturasList.concat(res[0].pagamentos);
          this.facets = res[0].info;
          //this.assinaturaDetails = false;
          if(res[0].assinatura) {
            this.assinaturaDetails = res[0].assinatura;
          }

        })
      }
    },
    watch: {
      filtros: {
        deep: true,
        handler(){
          this.filtrosAlterados = true
        }
      }
    },
    data() {
      return {
        loading: false,
        skiped: 0,
        facets: {},
        usuariosList:[],
        faturasList:[],
        assinaturaDetails: {},
        idxList:[],
        status: [{'nome': 'Pendente', 'valor': 'pending'}, {'nome': 'Pago', 'valor': 'paid'}, {'nome': 'Cancelado', 'valor': 'canceled'}, {'nome': 'Pago Parcialmente', 'valor': 'partially_paid'}, {'nome': 'Reembolsado', 'valor': 'refunded'}, {'nome': 'Expirado', 'valor': 'expired'}, {'nome': 'Autorizado', 'valor': 'authorized'}],
        coresStatus: ['warning','info','primary','info','info','success','danger','danger'],
        filtrosAlterados: false,
        filtroAberto: false,
        aplicandoFiltros: false,
        filtros: {
            status: null,
            none: null
        },
        opcoesFiltros: {
          dentista: [],
          paciente: [],
        }
      }
    },
    mounted(){
      this.initLoad(0);
    }
  };
</script>
<style lang="scss" scoped>
.filtros .form-group{
  width: 150px;
}
.head {
  display: flex;
  justify-content: space-between;
}
.actions a {
  font-size: 16px;
  margin: 0 5px;
  cursor: pointer;
}
</style>
